import { IndexerValueTypes } from './IndexerValueTypes';
import { CreditProposal } from './CreditProposal';
import { PostalAddress } from './PostalAddress';
import { Job } from './Job';
import { CounterOfferData } from './CounterOffer';

export enum CreditProposalFlowStep {
  PAYMENT = 'PAYMENT',
  OCR = 'OCR',
  ESIGNATURE = 'ESIGNATURE',
  DECISION_PAC = 'DECISION_PAC',
  DECISION = 'DECISION',
  ACTIVATION = 'ACTIVATION',
  UPDATE_IBAN = 'UPDATE_IBAN',
  BANK_READER = 'BANK_READER',
  CLASSIFICATION = 'CLASSIFICATION',
  UPDATE = 'UPDATE',
  VERIFICATION = 'VERIFICATION',
  PERSONAL_FINANCES = 'PERSONAL_FINANCES',
  COUNTER_OFFER = 'COUNTER_OFFER',
}
export interface CreditProposalResult extends CreditProposal {
  [key: string]: IndexerValueTypes;
  credit_proposal_id: string;
  status: string;
  loan_amount: number;
  application: string;
  good_type: string;
  merchant_id: string;
  flow_step: CreditProposalFlowStep;
  order_id: string;
  ocr_id: string;
  source_application: string;
  counter_offers: CounterOfferData[];
  counter_offer_id?: string;
}

export interface CreditProposalUpdate {
  op: string;
  path: string;
  value: PostalAddress | Job | string | any;
}
